export const PAYWALL_PLACEMENTS = [
  'onboarding', 'trial_end', 'family', 'voice_ai', 'extras', 'plus_screen',
] as const;

export type PaywallPlacement = typeof PAYWALL_PLACEMENTS[number];
